import { createFileRoute, Link } from "@tanstack/react-router"
import { DateFormatType, formatDate } from "~/utils/datetime"
import { categoryLandings, docsByCategory } from "~/utils/docs"

export const Route = createFileRoute("/_auth/internal/docs/_layout/")({
  component: DocsIndex,
})

function DocsIndex() {
  return (
    <div className="max-w-3xl mx-auto px-8 py-10">
      <h1 className="text-2xl font-semibold mb-2">Internal Docs</h1>
      <p className="text-fg-subtle mb-8">
        Engineering reference for Hakio Core. Pick a document from the sidebar or below.
      </p>

      <div className="flex flex-col gap-8">
        {docsByCategory.map(({ category, docs }) => {
          const landing = categoryLandings.get(category)
          return (
            <section key={category}>
              <h2 className="text-sm font-semibold uppercase tracking-wide text-fg-subtle mb-3">
                {landing ? (
                  <Link
                    to="/internal/docs/$slug"
                    params={{ slug: landing.slug }}
                    className="hover:text-fg"
                  >
                    {category}
                  </Link>
                ) : (
                  category
                )}
              </h2>
              <ul className="flex flex-col gap-3">
                {docs.map((doc) => (
                  <li key={doc.slug}>
                    <Link
                      to="/internal/docs/$slug"
                      params={{ slug: doc.slug }}
                      className="block rounded border border-base p-4 hover:bg-subtle"
                    >
                      <div className="flex items-baseline gap-2">
                        <span className="font-medium">{doc.title}</span>
                        {doc.lastUpdated && (
                          <span className="text-xs text-fg-subtle">
                            Updated {formatDate(doc.lastUpdated, DateFormatType.FullDateShort)}
                          </span>
                        )}
                      </div>
                      {doc.description && (
                        <p className="mt-1 text-sm text-fg-subtle line-clamp-2">
                          {doc.description}
                        </p>
                      )}
                      {doc.tags.length > 0 && (
                        <div className="mt-2 flex flex-wrap gap-1">
                          {doc.tags.map((tag) => (
                            <span
                              key={tag}
                              className="rounded bg-subtle px-1.5 py-0.5 text-xs text-fg-subtle"
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          )
        })}
      </div>
    </div>
  )
}
